import React from 'react';
import { Grid } from '@mui/material';
import { OptionChip, Text } from 'library';
import { historyTypes, updateSelectedTypes } from '../historyTypes';

export default function LocationHistoryHeader({
    title = 'History',
    selectedTypes,
    setSelectedTypes,
}: {
    title?: string;
    selectedTypes: string[];
    setSelectedTypes: (historyTypes: string[]) => void;
}) {
    return (
        <Grid container direction="row" gap={1} alignItems="center">
            <Text bold>{title}</Text>
            {historyTypes.map((historyType) => (
                <OptionChip
                    key={historyType}
                    label={historyType}
                    selected={selectedTypes.includes(historyType)}
                    limitWidth={false}
                    onClick={() =>
                        updateSelectedTypes(
                            selectedTypes.includes(historyType)
                                ? selectedTypes.filter((t) => t !== historyType)
                                : [...selectedTypes, historyType],
                            selectedTypes,
                            setSelectedTypes,
                        )
                    }
                />
            ))}
        </Grid>
    );
}
